<script lang="ts">
  let fps = $state(0);
  let events = $state(0);
  let frames = 0;
  let evCount = 0;

  $effect(() => {
    let raf = 0;
    let last = performance.now();
    const onAny = () => evCount++;
    window.addEventListener('pointermove', onAny, { passive: true });
    const loop = (t: number) => {
      frames++;
      if (t - last >= 1000) {
        fps = frames; events = evCount;
        frames = 0; evCount = 0; last = t;
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); window.removeEventListener('pointermove', onAny); };
  });
</script>

<div class="debug">{fps} fps · {events} ev/s</div>

<style>
  .debug { position: fixed; bottom: 8px; right: 8px; z-index: 100; font-size: 11px; font-variant-numeric: tabular-nums; background: rgba(0,0,0,0.6); color: #0f0; padding: 4px 8px; border-radius: 6px; pointer-events: none; }
</style>
